<div class="oc-toast">
  <button mat-icon-button class="oc-toast__close-btn" (click)="close()">
    <mat-icon class="material-icons-outlined">close</mat-icon>
  </button>

  <div class="oc-toast__request">
    <div class="oc-toast__header" [matTooltip]="requests().filename" [matTooltipShowDelay]="500">
      <mat-icon class="oc-toast__icon material-icons-outlined">description</mat-icon>
      <span class="oc-toast__filename">{{ requests().filename }}</span>
    </div>

    <div class="oc-toast__status-row" [class]="{'is-completed': isComplete()}">
      <span class="oc-toast__status">{{ requests().statusAlias }}</span>
      <span class="oc-toast__percent">{{ requests().progress }}%</span>
    </div>

    <div class="oc-toast__actions">
      <mat-progress-bar [mode]="isComplete() ? 'determinate' : 'indeterminate'" [value]="requests().progress" class="oc-toast__progress" />

      @if (isComplete()) {
        <button
          mat-icon-button
          color="primary"
          class="oc-toast__download-btn"
          animate.enter="is-enter"
          (click)="downloadFile()"
          [matTooltip]="'Download ' + requests().filename"
          [matTooltipShowDelay]="500">
          <mat-icon class="material-icons-outlined oc-toast__download-icon">file_download</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
